import React from "react";

import NoItemImage from "../assets/images/no-recipes-found.png";

export default ({ message }) => {
    return <div className="alert alert-info text-center w-100 my-3 p-3 no-items-found">
        <img src={NoItemImage} alt="No items found" />
        <div className="mt-3">{message ? message : 'No items found!'}</div>
    </div>
}